<template>
  <div class="flex flex-col h-full">
    <div class="grow p-5  overflow-y-auto">
      <div>
        添加过滤条件来限定关联数据范围
      </div>
      <div v-for="(filter, index) in filters" :key="index" class="flex leading-8 py-1">
        <div class="flex grow justify-between flex-row">
          <div class="w-1/2 justify-between flex">
            <div class="w-1/2 h-8 flex items-center">
              <el-select v-model="filter.link" size="mini">
                <el-option v-for="field in fields" :key="field.name" :label="field.text" :value="field.name" />
              </el-select>
            </div>
            <div class="mx-2 w-1/2 m-auto flex justify-center method">
              <el-dropdown trigger="click" @command="filter.method=$event">
                <span class="el-dropdown-link">
                  {{ getMethodName(filter.method) }}<i class="el-icon-arrow-down el-icon--right" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="method in methods" :key="method.value" :command="method.value">{{ method.name }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div class="w-1/2 flex-row flex">
            <div class="mx-1">
              <el-select v-model="filter.type" size="mini" placeholder="请选择">
                <el-option label="当前表单字段" value="widget" />
                <el-option label="自定义" value="fixed" />
              </el-select>
            </div>
            <div class="mx-1">
              <el-select v-if="filter.type === 'widget'" v-model="filter.rely" size="mini" placeholder="请选择">
                <el-option v-for="field in widgets" :key="field.key" :label="field.name" :value="field.key" />
              </el-select>
              <el-input v-else v-model="filter.fixed" size="mini" />
            </div>
          </div>
        </div>

        <i class="bi bi-trash w-4 px-2 cursor-pointer" @click="onDelete(index)" />
      </div>
      <div>
        <span class="cursor-pointer text-sky-500 text-sm h-9 leading-9" @click="onAdd">
          <i class="bi bi-plus text-base" />
          添加过滤条件
        </span>
      </div>
    </div>
    <div class="mt-1 text-right border-t h-15 p-2 w-full">
      <el-button type="primary" @click="onLinkFilterConfirm">确定</el-button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'LinkFilter',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    fields: {
      type: Array,
      default: () => [],
    },
    widgets: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      methods: [
        {
          name: '等于',
          value: 'eq',
        },
        {
          name: '不等于',
          value: 'neq',
        },
      ],
      filters: _.cloneDeep(this.value),
    }
  },
  methods: {
    getMethodName(val) {
      return this.methods.find(item => item.value === val).name
    },
    onDelete(index) {
      this.filters.splice(index, 1)
    },
    onAdd() {
      this.filters.push({
        link: '',
        rely: '',
        type: 'widget',
        method: 'eq',
      })
    },
    onLinkFilterConfirm() {
      this.$emit('input', this.filters)
    },
  },
}
</script>

<style scoped>

</style>
